import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, SettingsIcon, ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { COMPANY, waLink } from '../data/company';
const FLEET = [{
  name: 'Honda Brio AT',
  type: 'City Car · Otomatis',
  seats: '4 Kursi',
  trans: 'Automatic',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/1db0e199-d0ce-4b88-b0ea-f3b5c2885e4d.jpg'
}, {
  name: 'Suzuki Ertiga MT',
  type: 'MPV · Manual',
  seats: '7 Kursi',
  trans: 'Manual',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/b3bcd985-ecd8-48b2-9f3f-b0409f8ee5d2.jpg'
}, {
  name: 'Toyota All New Avanza AT',
  type: 'MPV · Otomatis',
  seats: '7 Kursi',
  trans: 'Automatic',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/4a54fbb2-59f5-4b20-880f-bfb5f74f042d.jpg'
}, {
  name: 'Toyota Innova Reborn AT',
  type: 'Premium MPV · Otomatis',
  seats: '7 Kursi',
  trans: 'Automatic',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/b276d3fb-e0ad-4015-89b3-cf1df775e511.jpg'
}];
export function Fleet() {
  return <section id="armada" className="relative bg-ink py-24" data-id="element-66" data-mp="i8np6ahwmrkj">
      <div className="mx-auto max-w-7xl px-5" data-id="element-67" data-mp="iah041zjvxyc">
        <SectionHeading eyebrow="Armada" title={<>Pilihan <span className="text-gold-gradient" data-id="element-69" data-mp="n5e6t29cxv82">Armada Premium</span></>} subtitle="Setiap kendaraan dirawat dengan teliti agar selalu prima dan nyaman untuk perjalanan Anda." data-id="element-68" data-mp="n77fen3j6pip" />

        <div className="mt-14 grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-4" data-id="element-70" data-mp="1fubn4zu0dhy6">
          {FLEET.map((car, i) => <motion.div key={car.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.1
        }} className="group flex flex-col overflow-hidden rounded-3xl border border-white/5 bg-ink-card transition-all duration-300 hover:border-gold/40" data-id="element-71" data-mp="15y8erc8kcn2s" data-mpi={i}>
              <div className="relative overflow-hidden" data-id="element-72" data-mp="1s7oy0wt0gwgx">
                <img src={car.img} alt={car.name} className="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-73" data-mp="1nfxayw92d8vj" />
                <span className="absolute left-3 top-3 rounded-full bg-ink/80 px-3 py-1 text-[11px] font-medium text-gold gold-border" data-id="element-74" data-mp="1efs7gx6zqumn">
                  {car.type}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5" data-id="element-75" data-mp="14g9p2l6qbgwp">
                <h3 className="font-display text-lg font-semibold text-white" data-id="element-76" data-mp="14iw6dcjf9as4">{car.name}</h3>

                <div className="mt-3 flex items-center gap-4 text-xs text-white/55" data-id="element-77" data-mp="zk2utpnp3tul">
                  <span className="inline-flex items-center gap-1.5" data-id="element-78" data-mp="2yuawhugchc8e">
                    <UsersIcon className="h-4 w-4 text-gold" data-id="element-79" data-mp="2tx2epuz3za7o" /> {car.seats}
                  </span>
                  <span className="inline-flex items-center gap-1.5" data-id="element-80" data-mp="32byphsd3yeii">
                    <SettingsIcon className="h-4 w-4 text-gold" data-id="element-81" data-mp="36ed2vwy0cm2e" /> {car.trans}
                  </span>
                </div>

                <a href={waLink(`Halo ${COMPANY.name}, saya ingin booking ${car.name}.`)} target="_blank" rel="noopener noreferrer" className="btn-glow-gold mt-5 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold" data-id="element-82" data-mp="3b6czpgis6yur">
                  Booking Sekarang <ArrowRightIcon className="h-4 w-4" data-id="element-83" data-mp="2setz1gc8bwvw" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}